const SHOP_VIEW_STATE_KEY = "shop:view-state";
const ITEMS_PER_PAGE_GRID = 4;
const ITEMS_PER_PAGE_LIST = 10;

export const ITEMS_INCREMENT_GRID = 4;
export const ITEMS_INCREMENT_LIST = 8;

const getDefaultVisibleCount = (grid) =>
  grid ? ITEMS_PER_PAGE_GRID : ITEMS_PER_PAGE_LIST;

export const persistShopViewState = ({ visibleCount, search, grid }) => {
  const viewState = {
    visibleCount,
    search,
    grid,
  };

  sessionStorage.setItem(SHOP_VIEW_STATE_KEY, JSON.stringify(viewState));
};

export const getInitialVisibleCount = (grid) => {
  try {
    const rawState = sessionStorage.getItem(SHOP_VIEW_STATE_KEY);
    if (!rawState) return getDefaultVisibleCount(grid);

    const { visibleCount } = JSON.parse(rawState);
    return Number.isFinite(visibleCount) && visibleCount > 0
      ? visibleCount
      : getDefaultVisibleCount(grid);
  } catch {
    return getDefaultVisibleCount(grid);
  }
};

export const getRestoredVisibleCount = ({ grid, searchQuery }) => {
  try {
    const rawState = sessionStorage.getItem(SHOP_VIEW_STATE_KEY);
    if (!rawState) return null;

    const savedState = JSON.parse(rawState);
    const savedSearch = String(savedState?.search || "");
    const sameGrid = Boolean(savedState?.grid) === Boolean(grid);

    if (savedSearch !== searchQuery || !sameGrid) return null;

    const savedVisibleCount = Number(savedState?.visibleCount);
    if (Number.isFinite(savedVisibleCount) && savedVisibleCount > 0) {
      return savedVisibleCount;
    }

    return null;
  } catch {
    // Ignore malformed state and fall back to default behavior.
    return null;
  }
};
